// extracted by mini-css-extract-plugin
export default {"right":"_3PU3","left":"_3_ZO"};